import React, { useEffect, useRef, useState } from "react";
import Header from "./Header";
import SubHeader from "./SubHeader";
import DataTable, { formatNum } from "./DataTable";
import TableLoader from "../TableLoader";
import Apiauth from "../../../API/Apiauth";
import MetalChart from "./graph/MetalChart";

function mapRows(apiData = []) {
  return apiData.map((row) => ({
    style_name: row.style_name,
    design_no: row.design_no,
    qty: row.qty,
    tagPrice: row.tag_price,
    sellingPrice: row.selling_price,
    qty_sum_pct: row.qty_sum_pct,
    amount_sum_pct: row.amount_sum_pct,
  }));
}

function mapTotals(apiTotals = {}, hasData = false) {
  return {
    qty: apiTotals.qty,
    tagPrice: apiTotals.tag_price,
    sellingPrice: apiTotals.selling_price,
    qty_sum: apiTotals.qty_sum,
    amount_sum: apiTotals.amount_sum,
    qty_sum_pct: hasData ? 100 : 0,
    amount_sum_pct: hasData ? 100 : 0,
  };
}

function mapMetrics(summary = {}) {
  return [
    { label: "Style", value: formatNum(summary.total_styles) },
    { label: "Qty", value: formatNum(summary.total_qty) },
    {
      label: "Top Selling Style (by Amount)",
      value: summary.top_style_by_amount ?? "-",
    },
    {
      label: "Top Selling Style (by Qty)",
      value: summary.top_style_by_qty ?? "-",
    },
  ];
}

const STYLE_COLUMNS = [
  { key: "_index", label: "#", align: "center", width: 40 },
  { key: "style_name", label: "Style", align: "left", width: 170 },
  { key: "design_no", label: "Design no.", align: "left", width: 180 },
  { key: "qty", label: "Qty", align: "right", width: 120 },
  { key: "tagPrice", label: "Tag Price", align: "right", width: 170 },
  { key: "sellingPrice", label: "Selling Price", align: "right", width: 170 },
  { key: "qty_sum_pct", label: "Qty% from over all sales", align: "right", width: 220 },
  {
    key: "amount_sum_pct",
    label: "Amount% from over all sales",
    align: "right",
    width: 250,
  },
];

const DEFAULT_PAGE_SIZE = 10;
const CHART_MAX_LIMIT = 100000;

const Style = () => {
const [rows, setRows] = useState([]);
  const [chartRows, setChartRows] = useState([]);
  const [totals, setTotals] = useState(null);
  const [metrics, setMetrics] = useState([]);
  const [filter, setFilter] = useState({});
  const [loading, setLoading] = useState(true);
  const [appliedFilters, setAppliedFilters] = useState({});
  const [totalRecords, setTotalRecords] = useState(0);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE);
  const [showCharts, setShowCharts] = useState(false); 
 
  const fetchSalesByStyle = ({page: p = 1,
    limit: l = pageSize,
    ...rest}={}) => {
   
    setLoading(true);

    Apiauth({ page: p, limit: l, ...rest }, "Inventory/reports/salesByStyle")
      .then((res) => {
        if (res?.code === 200) {
          setRows(mapRows(res.data));
          setTotals(mapTotals(res.totals, Array.isArray(res.data) && res.data.length > 0));
          setMetrics(mapMetrics(res.summary));
          setFilter(res.filters ?? {});
         setTotalRecords(res?.pagination?.total ?? 0);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

   const fetchChartReport = (filters = {}) => {
    setLoading(true);
    Apiauth(
      { page: 1, limit: CHART_MAX_LIMIT, ...filters },
      "Inventory/reports/salesByStyle"
    )
      .then((res) => {
        if (res?.code === 200) {
          setChartRows(mapRows(res.data));
        }
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    fetchSalesByStyle({ page: 1, limit: DEFAULT_PAGE_SIZE });
  }, []);

 useEffect(() => {
    if (showCharts) {
      fetchChartReport(appliedFilters);
    }
  }, [showCharts, appliedFilters]);

  function handleFetchData({ page: newPage, limit: newLimit }) {
    if (newLimit !== pageSize) setPageSize(newLimit);
    setPage(newPage);
    fetchSalesByStyle({ ...appliedFilters, page: newPage, limit: newLimit });
  }

  function handleFilterApply(filterParams = {}) {
    setAppliedFilters(filterParams);
    setPage(1);
    fetchSalesByStyle({ ...filterParams, page: 1, limit: pageSize });
  }

  return (
    <>
      <Header title="Sales by Style" metrics={metrics} />
       <SubHeader
       filters={filter} showCharts={showCharts}  setShowCharts={setShowCharts} onFilterApply={handleFilterApply}
      />
      {loading ? (
        <TableLoader />
      ) : (
        showCharts?(<MetalChart rows={chartRows} text="Style"/>):
      (  <DataTable
          columns={STYLE_COLUMNS}
          data={rows}
          totals={totals}
          showSearch={true}
          showDateRange={true}
          pageLimit={pageSize}
          totalRecords={totalRecords}
          currentPage={page}
          onPageChange={setPage}
          fetchData={handleFetchData}
        />)
      )}
    </>
  );
};

export default Style;